module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,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
